module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,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
